module.exports = {
  externalObjectLoader: function(url, onloadScript, id) {
    var doc, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = 'javascript:false';
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.css = 'width: 0;height: 0;border: 0';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      iframe.src = "javascript:var d=document.open();d.domain='" + document.domain + "';void 0";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (typeof dom !== "undefined" && dom !== null) {
        this.domain = dom;
      }
      scriptInit = this.createElement('script');
      scriptInit.type = 'text/javascript';
      scriptInit.innerHTML = 'Groupon=window.parent.Groupon;$=window.parent.$';
      this.body.appendChild(scriptInit);
      js = this.createElement('script');
      js.type = 'text/javascript';
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  },
  externalObjectLoaderOnready: function(fn) {
    if (typeof fn === 'function') {
      return $(document).ready(fn);
    }
  }
};

//# sourceMappingURL=data:application/json;base64,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
